import { useTranslation } from 'react-i18next';

export default function useTranslateFilter() {
  const { t: tKlassStatus } = useTranslation('translation', {
    keyPrefix: 'klassStatus',
  });

  const { t: tUserStatus } = useTranslation('translation', {
    keyPrefix: 'userStatus',
  });

  const { t: tEnrollmentStatus } = useTranslation('translation', {
    keyPrefix: 'enrollmentStatus',
  });

  const { t: tUserTypes } = useTranslation('translation', {
    keyPrefix: 'userTypes',
  });

  const { t: tCourseFormats } = useTranslation('translation', {
    keyPrefix: 'courseFormats',
  });

  const { t: tDaysOfWeek } = useTranslation('translation', {
    keyPrefix: 'weekday',
  });

  type Filter = Exclude<string, 'unit' | 'unitId'>;

  const translate: {
    [key in Filter]: (text: string) => string;
  } = {
    status: tKlassStatus,
    enrollmentStatus: tEnrollmentStatus,
    userType: tUserTypes,
    userStatus: tUserStatus,
    staffStatus: tUserStatus,
    courseFormats: tCourseFormats,
    dayOfWeek: tDaysOfWeek,
  };

  const translateItem = ({ type, item }: { type: string; item: string }) => {
    switch (type) {
      case 'enrollmentStatus':
      case 'status':
      case 'userStatus':
      case 'userType':
      case 'staffStatus':
      case 'dayOfWeek':
      case 'courseFormats':
        return translate[type](item);
      default:
        return '';
    }
  };

  return { translateItem };
}
